import axios from "axios"
import React, {useEffect, useRef} from "react";
import {useDispatch} from "react-redux";
import {Route, Routes, useNavigate} from "react-router-dom";
import AdminLayout from "./horizon/layouts/AdminLayout";
import Login from "./views/Login";

axios.interceptors.response.use(
    response => {
        return { data: response.data };
    },
    error => {
        return Promise.reject(error);
    }
);

/**
 * Sets default Axios headers for admin requests.
 * @returns {void}
 */
function setDefaultHeaders() {
    axios.defaults.headers.common['admin'] = "true"
    axios.defaults.headers.common['Language'] = "fr"
    axios.defaults.headers.common['Content-Type'] = 'application/json'
}

/**
 * Checks token validity and redirects accordingly.
 * @param {Function} navigate - React Router navigate function
 */
function checkTokenAndRedirect(navigate) {
    const currentPath = window.location.pathname;
    axios.get("users/if_token_valid").then(() => {
        const isAdminRoute = currentPath.startsWith('/admin/');
        navigate(isAdminRoute ? currentPath : '/admin/dashboard');
    }).catch(() => {
        localStorage.removeItem('creativeAdminToken')
        navigate('/auth')
    });
}

/**
 * Root application component; sets up routes and validates admin token on mount.
 * @returns {React.ReactElement}
 */
function App() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isMounted = useRef(false);

    useEffect(() => {
        if (!isMounted.current) {
            setDefaultHeaders();
            checkTokenAndRedirect(navigate);
        }
        return () => { isMounted.current = true };
    }, [navigate, dispatch]);

    return (
        <Routes>
            <Route exact path="/" element={<Login />} />
            <Route path="/auth" element={<Login />} />
            <Route path="/admin/*" element={<AdminLayout />} />
        </Routes>
    );
}

export default App;
